import { gql } from "@apollo/client";

export const GET_STORE_ITEMS = gql`
  query getStoreItems {
    store_item(where: { is_active: { _eq: true } }, order_by: { cost: asc }) {
      store_item_id
      name
      slug
      description
      presentation
      type
      rarity
      cost
      asset_key
      is_active
    }
  }
`;

export const GET_USER_VETCOIN_PROFILE = gql`
  query getUserVetcoinProfile($userId: uuid!) {
    user_vetcoin_balance(where: { user_id: { _eq: $userId } }, limit: 1) {
      user_id
      balance
      updated_at
    }
    user_store_item(where: { user_id: { _eq: $userId } }) {
      user_store_item_id
      user_id
      store_item_id
      purchased_at
      store_item {
        store_item_id
        name
        slug
        presentation
        type
        rarity
        cost
        asset_key
      }
    }
    user_equipped_item(where: { user_id: { _eq: $userId } }) {
      user_equipped_item_id
      user_id
      item_type
      store_item_id
      store_item {
        store_item_id
        name
        slug
        presentation
        type
        rarity
        asset_key
      }
    }
  }
`;
